/**
 *
 * Asynchronously loads the component for GestioneAcl
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
